<div class="auth-root">
  <!-- Left: Branded Role Panel -->
  <div class="auth-panel" [ngClass]="currentRole.accentClass">
    <div class="auth-panel-inner">
      <!-- Logo row: logo left, role badge right -->
      <div class="auth-panel-logo-row">
        <img src="/images/interpanely_logo_light.png" alt="Interpanely" class="auth-logo-img" />
        <span class="auth-panel-role-badge">{{ currentRole.displayName }}</span>
      </div>

      <!-- Tagline + description -->
      <div class="auth-panel-content">
        <h1 class="auth-panel-tagline">{{ currentRole.tagline }}</h1>
        <p class="auth-panel-desc">{{ currentRole.description }}</p>
      </div>

      <!-- Role switcher dots -->
      <div class="auth-panel-dots">
        <span
          class="auth-panel-dot"
          [class.active]="role() === 'candidate'"
          (click)="role.set('candidate')"
        ></span>
        <span
          class="auth-panel-dot"
          [class.active]="role() === 'panel'"
          (click)="role.set('panel')"
        ></span>
        <span
          class="auth-panel-dot"
          [class.active]="role() === 'corporates'"
          (click)="role.set('corporates')"
        ></span>
      </div>
    </div>
  </div>

  <!-- Right: Form Panel -->
  <div class="auth-form-panel">
    <!-- Top bar with theme toggle -->
    <div class="auth-form-topbar">
      <button
        class="auth-theme-toggle"
        (click)="toggleTheme()"
        [title]="isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
      >
        <i class="pi" [ngClass]="isDark() ? 'pi-sun' : 'pi-moon'"></i>
      </button>
    </div>

    <!-- Centered form area -->
    <div class="auth-form-center">
      <div class="auth-form-wrap">
        <div class="auth-form-header">
          <h2 class="auth-form-title">
            {{ isForgotPassword() ? 'Reset Password' : 'Create Account' }}
          </h2>
          @if (!isForgotPassword()) {
            <p class="auth-form-subtitle">
              Join as a <strong>{{ currentRole.displayName }}</strong> - we'll send you a
              verification code
            </p>
          }
          @if (isForgotPassword()) {
            <p class="auth-form-subtitle">Enter your email and we'll send a reset code</p>
          }
        </div>

        <!-- Error -->
        @if (errorMsg()) {
          <div class="auth-error">
            <i class="pi pi-exclamation-circle"></i>
            @if (!showRegisterCta()) {
              <span>{{ errorMsg() }}</span>
            }
            @if (showRegisterCta()) {
              <span>
                @for (part of errorParts(); track part) {
                  @if (part.isLink) {
                    <a class="auth-inline-link" (click)="switchToRegister()">{{ part.text }}</a>
                  } @else {
                    {{ part.text }}
                  }
                }
              </span>
            }
          </div>
        }

        <form (ngSubmit)="onSubmit()" autocomplete="on">
          <!-- Email -->
          <div class="auth-field">
            <label class="auth-label" for="reg-email"
              >Email address <span class="auth-required">*</span></label
            >
            <input
              id="reg-email"
              type="email"
              pInputText
              [(ngModel)]="email"
              name="email"
              [placeholder]="emailPlaceholder"
              autocomplete="email"
              class="auth-input"
            />
          </div>

          <!-- Submit -->
          <button
            type="submit"
            pButton
            pRipple
            [disabled]="loading() || !email"
            class="auth-submit-btn"
          >
            @if (loading()) {
              <i class="pi pi-spin pi-spinner"></i>
            }
            @if (!loading()) {
              <span>
                {{ isForgotPassword() ? 'Send Reset Code' : 'Continue' }}
              </span>
            }
            @if (loading()) {
              <span>Sending…</span>
            }
          </button>
        </form>

        <!-- Social Federation - candidate only -->
        @if (role() === 'candidate' && !isForgotPassword()) {
          <div class="auth-divider">
            <span>or continue with</span>
          </div>
          <div class="auth-social-btns">
            <button
              class="auth-social-btn auth-social-btn--google"
              (click)="loginWithGoogle()"
              pRipple
            >
              <i class="pi pi-google"></i>
              <span>Google</span>
            </button>
          </div>
        }

        <!-- Footer -->
        <p class="auth-footer-text">
          Already have an account?
          <a class="auth-link" (click)="goToLogin()">Sign in</a>
        </p>
      </div>
    </div>
  </div>
</div>
